export { DashboardService } from './dashboard.service'

export { DashboardRequestResult } from './class/dashboard-request-result'

export { IDashboardItem } from './interface/dashboard-item'
export { IDashboardItemStorage } from './interface/dashboard-item-storage'
export { IDashboardList } from './interface/dashboard-list'
export { IDashboardListItem } from './interface/dashboard-list-item'

export { DashboardRequestStatus } from './enum/dashboard-request-status'
